<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Clientes</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['/']">Dashboard</a></li>
                    <li class="breadcrumb-item active">Clientes</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>
<!-- Main content -->
<section class="content">
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-xl-8 col-lg-10 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <app-new-cliente (updateData)="getData()"></app-new-cliente>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="searchForm">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <div class="form-group input-group-text">
                                                    <div
                                                        class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                        <input type="checkbox" class="custom-control-input" id="client_habilitado"
                                                            name="client_habilitado" [formControl]="searchForm.get('clienteHabilitado')">
                                                        <label class="custom-control-label d-none d-sm-block" for="client_habilitado"
                                                            id="client_habilitadoText">{{searchForm.get('clienteHabilitado').value ? "Cliente habilitado" :
                                                            "Cliente deshabilitado"}}</label>
                                                        <label class="custom-control-label d-block d-sm-none" for="client_habilitado"
                                                            id="client_habilitadoText2"><i class="fas" [ngClass]="searchForm.get('clienteHabilitado').value  ? 'fa-user-check' : 'fa-user-times'"></i></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <input class="form-control form-control-lg" [formControl]="searchForm.get('search')"
                                                id="inputSearch" name="inputSearch" type="text" placeholder="Buscar"
                                                aria-label="Search" autocomplete="off">
                                            <div class="input-group-append">
                                                <span class="input-group-text bg-info"><i
                                                        class="fas fa-search"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <app-lista-clientes [clientes]="clientes" (updateData)="getData()"></app-lista-clientes>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>